module.exports = __webpack_public_path__ + "img/logo-color.9eb2cc14.png";